export default __webpack_public_path__ + "static/media/list-check.b70fb56c.svg";